import { useState } from "react"
import { signIn, SignInOptions } from "next-auth/react"

/**
 * Custom hook for handling sign-in with a delay timer
 * @param defaultDelay Default delay in ms before completing sign-in
 */
export function useDelayedSignIn(defaultDelay = 2000) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<boolean | undefined>(false)

  const signInWithDelay = async (
    provider: string,
    options?: SignInOptions,
    delay = defaultDelay,
  ) => {
    setLoading(true)
    setError(false)

    try {
      await signIn(provider, {
        ...options,
      })

      await new Promise<void>((resolve) => {
        setTimeout(() => resolve(), delay)
      })
    } catch {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    setError,
    signInWithDelay,
  }
}
